<template>
  <div class="info">
    <!-- 顶部横幅 -->
    <div class="page-banner">
      <div class="banner-overlay">
        <div class="banner-content">
          <h1>关于我们</h1>
          <!-- <p>专业差旅管理，让商务出行更简单</p> -->
        </div>
      </div>
      <img src="/imgs/us.jpg" alt="关于我们">
    </div>

    <!-- 主要内容 -->
    <div class="container">
      <div class="content-wrapper">
        <!-- 公司概览 -->
        <div class="company-overview">
          <div class="overview-card">
            <div class="card-header">
              <div class="company-logo">
                <div class="logo-icon">✈️</div>
                <h2>北京邑维智能科技有限公司</h2>
                <!-- <p class="company-tagline">高新技术和科技型差旅管理领先品牌</p> -->
              </div>
              <div class="header-decoration"></div>
            </div>

            <div class="card-content">
              <!-- 公司简介 -->
              <div class="intro-section">
                <div class="section-header">
                  <span class="section-icon">🏢</span>
                  <h3>公司简介</h3>
                </div>
                <div class="section-content">
                  <p class="intro-text">
                    北京邑维智能科技有限公司成立于2024年04月15日，注册地位于北京市大兴区长子营镇民安路6号1层1091,
                    经营范围包括一般项目：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；软件开发；计算机系统服务；数据处理服务；软件销售；广告发布；广告设计、代理；广告制作；会议及展览服务（出国办展须经相关部门审批）；信息技术咨询服务；信息咨询服务（不含许可类信息咨询服务）；企业管理；专业设计服务；社会经济咨询服务；市场营销策划；货物进出口；技术进出口。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：广播电视节目制作经营；第二类增值电信业务。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）（不得从事国家和本市产业政策禁止和限制类项目的经营活动。）
                  </p>
                </div>
              </div>

              <!-- 发展成就 -->
              <div class="achievement-section">
               
                <div class="section-content">
                 
                  <div class="values-grid">
                    <div class="value-item">
                      <div class="value-icon">🎯</div>
                      <div class="value-content">
                        <h4>客户为先</h4>
                        <p>始终以客户需求为导向</p>
                      </div>
                    </div>
                    <div class="value-item">
                      <div class="value-icon">📊</div>
                      <div class="value-content">
                        <h4>实事求是</h4>
                        <p>基于事实和数据决策</p>
                      </div>
                    </div>
                    <div class="value-item">
                      <div class="value-icon">⚡</div>
                      <div class="value-content">
                        <h4>专业高效</h4>
                        <p>提供专业高效的解决方案</p>
                      </div>
                    </div>
                    <div class="value-item">
                      <div class="value-icon">💪</div>
                      <div class="value-content">
                        <h4>艰苦奋斗</h4>
                        <p>持续努力追求卓越</p>
                      </div>
                    </div>
                    <div class="value-item">
                      <div class="value-icon">🚀</div>
                      <div class="value-content">
                        <h4>开拓创新</h4>
                        <p>不断探索新的可能性</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

           
            </div>
          </div>
        </div>

       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "info",
  components: {},
  data() {
    return {
      href: "index.html",
    };
  },
  mounted() {
    document.title = "北京邑维智能科技有限公司";
  },
  methods: {
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转注册协议
    goXy() {
      this.$router.push("/xy");
    },
  },
};
</script>

<style lang="scss" scoped>
// 使用方案2的颜色变量
$primary-color: #d4b896;
$primary-dark: #bfa07d;
$primary-light: #e9d4b8;
$accent-color: #5a8fb4;
$text-dark: #2c3e50;
$text-light: #7f8c8d;
$background: #f9f7f2;
$card-bg: #ffffff;

.info {
  background: $background;
  min-height: 100vh;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;

  // 页面横幅
  .page-banner {
    width: 100%;
    height: 400px;
    position: relative;
    overflow: hidden;
    margin-bottom: 60px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .banner-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom,
          rgba(0, 0, 0, 0.3) 0%,
          rgba(0, 0, 0, 0.5) 100%);
      display: flex;
      align-items: center;
      justify-content: center;

      .banner-content {
        text-align: center;
        color: white;
        max-width: 800px;
        padding: 0 20px;

        h1 {
          font-size: 48px;
          font-weight: 700;
          margin-bottom: 20px;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        }

        p {
          font-size: 20px;
          opacity: 0.9;
          line-height: 1.6;
        }
      }
    }
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    .content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 40px;

      // 公司概览
      .company-overview {
        .overview-card {
          background: $card-bg;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          border: 1px solid rgba(212, 184, 150, 0.1);

          .card-header {
            padding: 40px 40px 20px;
            background: linear-gradient(135deg, rgba(212, 184, 150, 0.05) 0%, rgba(90, 143, 180, 0.03) 100%);
            text-align: center;

            .company-logo {
              .logo-icon {
                font-size: 60px;
                margin-bottom: 15px;
              }

              h2 {
                font-size: 32px;
                font-weight: 700;
                color: $text-dark;
                margin: 0 0 10px 0;
              }

              .company-tagline {
                font-size: 18px;
                color: $primary-color;
                font-weight: 500;
                margin: 0;
              }
            }

            .header-decoration {
              height: 3px;
              background: linear-gradient(90deg, $primary-color, $accent-color, $primary-color);
              margin: 20px auto 0;
              max-width: 200px;
              border-radius: 2px;
            }
          }

          .card-content {
            padding: 40px;

            .intro-section,
            .achievement-section,
            .business-section {
              margin-bottom: 50px;

              &:last-child {
                margin-bottom: 0;
              }

              .section-header {
                display: flex;
                align-items: center;
                gap: 12px;
                margin-bottom: 25px;
                padding-bottom: 15px;
                border-bottom: 2px solid rgba(212, 184, 150, 0.2);

                .section-icon {
                  font-size: 24px;
                }

                h3 {
                  font-size: 22px;
                  font-weight: 600;
                  color: $text-dark;
                  margin: 0;
                }
              }

              .section-content {

                .intro-text,
                .achievement-text {
                  font-size: 16px;
                  line-height: 1.8;
                  color: $text-dark;
                  text-align: justify;
                  margin-bottom: 20px;
                }

                .values-grid {
                  display: grid;
                  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                  gap: 20px;
                  margin-top: 30px;

                  .value-item {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    padding: 15px;
                    background: rgba(212, 184, 150, 0.05);
                    border-radius: 10px;
                    transition: all 0.3s ease;
                    border: 1px solid rgba(212, 184, 150, 0.1);

                    &:hover {
                      transform: translateY(-3px);
                      box-shadow: 0 6px 20px rgba(212, 184, 150, 0.15);
                      background: rgba(212, 184, 150, 0.1);
                    }

                    .value-icon {
                      font-size: 24px;
                      flex-shrink: 0;
                    }

                    .value-content {
                      h4 {
                        font-size: 16px;
                        font-weight: 600;
                        color: $text-dark;
                        margin: 0 0 5px 0;
                      }

                      p {
                        font-size: 14px;
                        color: $text-light;
                        line-height: 1.5;
                        margin: 0;
                      }
                    }
                  }
                }

                .business-grid {
                  display: grid;
                  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                  gap: 25px;

                  .business-card {
                    background: rgba(212, 184, 150, 0.05);
                    border-radius: 15px;
                    padding: 25px;
                    transition: all 0.3s ease;
                    border: 1px solid rgba(212, 184, 150, 0.1);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;

                    &:hover {
                      transform: translateY(-5px);
                      box-shadow: 0 8px 25px rgba(212, 184, 150, 0.15);
                      background: rgba(212, 184, 150, 0.1);
                    }

                    .card-icon {
                      font-size: 40px;
                      margin-bottom: 15px;
                      background: linear-gradient(135deg, $primary-color, $primary-dark);
                      width: 70px;
                      height: 70px;
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: white;
                    }

                    .card-content {
                      padding: 0;

                      h4 {
                        font-size: 18px;
                        font-weight: 600;
                        color: $text-dark;
                        margin: 0 0 15px 0;
                      }

                      p {
                        font-size: 14px;
                        color: $text-light;
                        line-height: 1.6;
                        margin: 0;
                        text-align: justify;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      // 公司优势
      .advantages-section {
        .advantages-card {
          background: $card-bg;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          padding: 40px;
          border: 1px solid rgba(212, 184, 150, 0.1);

          .advantages-header {
            text-align: center;
            margin-bottom: 40px;

            h3 {
              font-size: 28px;
              font-weight: 700;
              color: $text-dark;
              margin: 0 0 10px 0;
            }

            p {
              font-size: 18px;
              color: $text-light;
              margin: 0;
            }
          }

          .advantages-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 30px;

            .advantage-item {
              display: flex;
              align-items: flex-start;
              gap: 15px;
              padding: 20px;
              background: rgba(212, 184, 150, 0.05);
              border-radius: 12px;
              transition: all 0.3s ease;
              border: 1px solid rgba(212, 184, 150, 0.1);

              &:hover {
                transform: translateY(-3px);
                box-shadow: 0 6px 20px rgba(212, 184, 150, 0.15);
                background: rgba(212, 184, 150, 0.1);
              }

              .advantage-icon {
                font-size: 32px;
                flex-shrink: 0;
              }

              .advantage-content {
                h4 {
                  font-size: 18px;
                  font-weight: 600;
                  color: $text-dark;
                  margin: 0 0 8px 0;
                }

                p {
                  font-size: 14px;
                  color: $text-light;
                  line-height: 1.5;
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  .info {
    .page-banner {
      height: 300px;

      .banner-content {
        h1 {
          font-size: 36px;
        }

        p {
          font-size: 16px;
        }
      }
    }

    .container {
      padding: 0 15px;

      .content-wrapper {
        .company-overview .overview-card {
          .card-header {
            padding: 30px 20px 15px;

            .company-logo {
              h2 {
                font-size: 26px;
              }

              .company-tagline {
                font-size: 16px;
              }
            }
          }

          .card-content {
            padding: 30px 20px;

            .intro-section,
            .achievement-section,
            .business-section {
              .section-content {

                .values-grid,
                .business-grid {
                  grid-template-columns: 1fr;
                }
              }
            }
          }
        }

        .advantages-section .advantages-card {
          padding: 30px 20px;

          .advantages-grid {
            grid-template-columns: 1fr;
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .info {
    .page-banner {
      height: 250px;

      .banner-content {
        h1 {
          font-size: 28px;
        }
      }
    }

    .container .content-wrapper {
      .company-overview .overview-card {
        .card-header .company-logo {
          h2 {
            font-size: 22px;
          }
        }

        .card-content .intro-section,
        .card-content .achievement-section,
        .card-content .business-section {
          .section-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;

            h3 {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>